function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import SectionTheme from "./SectionTheme";
import SectionBase from "./SectionBase";
import SectionHeader from "./SectionHeader";
import SectionBody from "./SectionBody";
import SectionFooter from "./SectionFooter";
import Collapse from '@material-ui/core/Collapse';

const LayoutSection = (_ref) => {
  let _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? true : _ref$expanded,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "relative" : _ref$position,
      collapsible = _ref.collapsible,
      title = _ref.title,
      description = _ref.description,
      buttons = _ref.buttons,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["expanded", "position", "collapsible", "title", "description", "buttons", "children"]);

  if (!expanded) {
    return React.createElement(SectionBase, {
      position: position,
      collapsible: collapsible,
      expanded: expanded
    }, React.createElement(SectionHeader, _extends({}, props, {
      title: title,
      description: description,
      collapsible: collapsible,
      expanded: expanded
    })), React.createElement(Collapse, {
      in: expanded,
      timeout: "auto",
      unmountOnExit: true
    }, React.createElement(SectionBody, _extends({
      position: position
    }, props), children), expanded && React.createElement(SectionFooter, _extends({}, props, {
      buttons: buttons
    }))));
  }

  return React.createElement(SectionBase, {
    position: position,
    collapsible: collapsible,
    expanded: expanded
  }, React.createElement(SectionHeader, _extends({}, props, {
    title: title,
    description: description,
    collapsible: collapsible,
    expanded: expanded
  })), React.createElement(SectionBody, _extends({
    position: position
  }, props), children), expanded && React.createElement(SectionFooter, _extends({}, props, {
    buttons: buttons
  })));
};

LayoutSection.defaultProps = {
  padding: 2,
  spacing: 0
};
export default LayoutSection;